import { BaseApi } from '@/main/baseApi';

import { DepTableNames, DMS_MODULE, NAME } from './constants';

class AkcniProdejeProvider extends BaseApi {
	schemaUrl(tableName: DepTableNames) {
		return `/${this.area}/${tableName}/Schema`;
	}

	tableUrl(tableName: DepTableNames) {
		return `/${this.area}/${tableName}`;
	}
}

export const apiProvider = new AkcniProdejeProvider(DMS_MODULE, NAME);
